export function isLoopbackOrLinkLocalOrULA(host: string): boolean {
  // IPv6 loopback + link-local + ULA quick checks
  const lower = host.toLowerCase();
  return (
    lower === 'localhost' ||
    lower === '::1' ||
    lower.startsWith('fe80:') || // link-local
    lower.startsWith('fc') || // ULA fc00::/7 (covers fc and fd)
    lower.startsWith('fd') ||
    lower.endsWith('.local')
  );
}
